import { Component, OnInit } from '@angular/core';
import { ViewModeChangedEvent } from '../../../../utils/events/view-mode-changed-event';
import { AssetService } from '../../../../services/asset.service';
import { ViewMode } from '../../../../utils/view-mode';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CommunicationService } from '../../../../services/communication.service';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { environment } from '../../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-toggle-button',
    templateUrl: './toggle-button.component.html',
    styleUrls: ['./toggle-button.component.scss'],
    standalone: true
})
export class ToggleButtonComponent implements OnInit {

    readonly viewModeCookieName = 'bv_view_mode';

    show: boolean;
    isIE: boolean;
    isFirefox: boolean;
    isMicrosoftEdge: boolean;
    isSafari: boolean;

    constructor(public applicationStateService: ApplicationStateService,
                private cookieService: CookieService,
                private deviceService: DeviceDetectorService,
                private communicationService: CommunicationService,
                public assetService: AssetService) {
    }

    ngOnInit(): void {
        this.show = !(this.deviceService.device() === 'ipad' ||
            this.deviceService.device() === 'iphone' ||
            this.deviceService.device() === 'android'
        );
        this.isIE = this.deviceService.browser() === 'ie';
        this.isMicrosoftEdge = this.deviceService.browser() === 'ms-edge';
        this.isFirefox = this.deviceService.getDeviceInfo().browser === 'firefox';
        this.isSafari = this.deviceService.getDeviceInfo().browser === 'safari';
        this.changeViewMode(this.applicationStateService.currentViewMode.slug);
    }

    changeViewMode(viewModeSlug: string): void {
        switch (viewModeSlug) {
            case 'scroll':
                if (this.applicationStateService.currentViewMode.slug !== viewModeSlug) {
                    this.applicationStateService.zoomLevel = environment.minZoomLevel;
                    this.applicationStateService.currentViewMode = ViewMode.getScrollViewMode();
                    const event: ViewModeChangedEvent = new ViewModeChangedEvent();
                    event.newViewMode = ViewMode.getScrollViewMode();
                    this.communicationService.announceViewModeChange(event);
                }
                break;
            default:
                if (this.applicationStateService.currentViewMode.slug !== viewModeSlug) {
                    this.applicationStateService.zoomLevel = environment.minZoomLevel;
                    this.applicationStateService.currentViewMode = ViewMode.getDefaultViewMode();
                    const event: ViewModeChangedEvent = new ViewModeChangedEvent();
                    event.newViewMode = ViewMode.getScrollViewMode();
                    this.communicationService.announceViewModeChange(event);
                }
        }

        const tenYears = 365 * 10;
        this.cookieService.set(
            this.viewModeCookieName,
            this.applicationStateService.currentViewMode.slug,
            tenYears,
            '/',
            undefined,
            true,
            'Strict');
        setTimeout(() => {
            const toggleButtons = ($('.view-mode-toggle-button') as any);
            toggleButtons.blur();
            toggleButtons.tooltip('hide');
        }, 500);
    }

    isDefaultViewMode(): boolean {
        const currentViewModeSlug = this.applicationStateService.currentViewMode.slug;

        return [ViewMode.getDefaultViewMode().slug, ViewMode.getMobileDefaultViewMode().slug]
            .includes(currentViewModeSlug);
    }

}
